import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { SocketProvider } from "./context/SocketContext";
import { ThemeProvider } from "./context/ThemeContext";
import { I18nProvider } from "./context/I18nContext";
import { registerServiceWorker, initLazyLoading } from "./utils/mobilePerformance";
import "./styles/global.css";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SocketProvider>
          <ThemeProvider>
            <I18nProvider>
              <App />
            </I18nProvider>
          </ThemeProvider>
        </SocketProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Initialize mobile performance optimizations
if (typeof window !== 'undefined') {
  if (!window.__wavvyBootstrapDone) {
    window.__wavvyBootstrapDone = true;

    // Register service worker for offline support and PWA (idempotent)
    registerServiceWorker().catch(() => {
      console.log('Service Worker registration skipped');
    });

    // Initialize lazy loading for images
    initLazyLoading();

    // Re-initialize lazy loading when DOM changes
    if (typeof MutationObserver !== "undefined" && typeof document !== "undefined" && document.body) {
      const observer = new MutationObserver(() => {
        initLazyLoading();
      });
      observer.observe(document.body, { subtree: true, childList: true });
      window.__wavvyLazyObserver = observer;
    }
  }
}

